import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import './App.css';
import MainPage from './pages/MainPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ProfilePage from './pages/ProfilePage';
import OAuthSuccess from './pages/OAuthSuccess';
import KtruAnalyticsPage from './pages/KtruAnalyticsPage';
import OkpdTreePage from './pages/OkpdTreePage';
import logo from "./assets/logo_ktry.jpeg";
import FeedbackModal from "./components/FeedbackModal";

// =========================
// HEADER
// =========================

const Header = ({ user, onLogout }) => {
    const navigate = useNavigate();

    return (
        <div className="header">
            <div className="header-content">

                <div className="logo-block">
                    <img
                        src={logo}
                        className="logo-img"
                        onClick={() => window.location.href = '/'}
                        alt="logo"
                    />
                    <span className="logo-tagline">Поиск производителей по КТРУ</span>
                </div>

                <div className="header-nav">
                    <button className="header-nav-link" onClick={() => window.location.href = '/'}>
                        Главная
                    </button>
                    <button className="header-nav-link" onClick={() => navigate('/okpd-tree')}>
                        Справочник ОКПД
                    </button>
                </div>

                <div className="auth-block">
                    {user ? (
                        <button
                            className="btn-secondary"
                            onClick={() => navigate("/profile")}
                        >
                            Профиль
                        </button>
                    ) : (
                        <button
                            className="btn-login"
                            onClick={() => navigate("/login")}
                        >
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
                            Войти
                        </button>
                    )}
                </div>

            </div>
        </div>
    );
};

// =========================
// FOOTER
// =========================
const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer-content">

                <div className="footer-left">
                    <div className="footer-brand">© 2026 Оптиматек. Все права защищены.</div>
                    <div className="footer-links">
                        <a href="/privacy">Политика конфиденциальности</a>
                        <a href="/terms">Пользовательское соглашение</a>
                    </div>
                </div>

                <div className="footer-right">
                    <div className="footer-requisites-title">Реквизиты:</div>
                    <div>ООО "Оптиматек"</div>
                    <div>ИНН: 3000023067</div>
                    <div>КПП: 300001001</div>
                    <div>ОГРН: 1253000006159</div>
                </div>

            </div>
        </footer>
    );
};

function App() {
    const [user, setUser] = React.useState(null);
    const [loading, setLoading] = React.useState(true);

    React.useEffect(() => {
        const token = localStorage.getItem('token');
        const savedUser = localStorage.getItem('user');
        if (token && savedUser) {
            setUser(JSON.parse(savedUser));
        }
        setLoading(false);
    }, []);

    const handleLogin = (userData, token) => {
        localStorage.setItem('token', token);
        localStorage.setItem('user', JSON.stringify(userData));
        setUser(userData);
    };

    const handleLogout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        setUser(null);
    };

    if (loading) {
        return (
            <div className="loading">
                <div className="spinner"></div>
            </div>
        );
    }

    return (
        <Router>
            <Header user={user} onLogout={handleLogout} />

            <Routes>
                <Route path="/" element={<MainPage user={user} />} />

                <Route
                    path="/login"
                    element={
                        user ? <Navigate to="/" /> : <LoginPage onLogin={handleLogin} />
                    }
                />

                <Route
                    path="/register"
                    element={
                        user ? <Navigate to="/" /> : <RegisterPage onLogin={handleLogin} />
                    }
                />

                <Route
                    path="/profile"
                    element={
                        user ? <ProfilePage user={user} /> : <Navigate to="/login" />
                    }
                />

                <Route
                    path="/oauth-success"
                    element={<OAuthSuccess onLogin={handleLogin} />}
                />

                <Route
                    path="/ktru-analytics"
                    element={<KtruAnalyticsPage />}
                />

                <Route
                    path="/okpd-tree"
                    element={<OkpdTreePage />}
                />
            </Routes>

            <Footer />
            <FeedbackModal />
        </Router>
    );
}

export default App;